import { withPrefix } from 'gatsby'
import variables from 'src/styles/variables'

export default {
  metadata: {
    title: 'Cutting edge risk selection and dynamic pricing technology. - artificial',
    desc: 'Give your customers an attractive and engaging experience and improve their conversion and retention rates with simple, digital distribution.',
  },
  ArHeroHeader: {
    animation: {
      id: 'distribute_hero',
    },
    title: 'Distributing digitally',
    description: 'A faster and more direct route to market.',
    cta: {
      label: 'Request a demo',
    },
  },
  ArTextWithImageHalvedOnTablet: {
    items: [
      {
        title: 'Improve the client experience',
        description: [
          'Give your customers an attractive and engaging experience and improve their conversion and retention rates.',
          { tag: 'br' },
          { tag: 'br' },
          'The ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' platform allows data to be collected seamlessly, so you can sell insurance policies in a way that your customers will love.',
        ],
        image: {
          alt: 'Collect insurance policy data easily with Artificial Distribute',
          url: withPrefix('img/ArTextWithImage4.png'),
        },
        scComponentMargins: {
          top: ['60px', '45px', '160px'],
          bottom: ['0', '0', '0'],
        },
        scTitleBottomMargins: ['20px', '40px', '30px'],
        scImageMargins: {
          right: ['-10px', '0', '0'],
          bottom: ['40px', '0', '0'],
          left: [`${ -variables.gridGutterMobile }px`, `-51%`, '-100px'],
        },
        scTextWrapperPaddings: {
          top: ['0', '20px', '0'],
          bottom: ['0', '20px', '0'],
        },
        scImageWidth: [null, 660, 660],
        scGap: [0, 50, 183],
        scTitleMaxWidth: ['none', '220px', '500px'],
      },
      {
        title: 'Get to market faster than ever',
        description: 'Speed up your route to market with our digital distribution tools. Our platform allows your customers to quote and buy insurance any time or place at a fraction of the speed it used to take.',
        image: {
          alt: 'Digital insurance tools and interfaces',
          url: withPrefix('img/ArTextWithImage5.png'),
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scComponentMargins: {
          top: ['40px', '0', '160px'],
          bottom: ['0', '0', '0'],
        },
        scImageWidth: [null, 580, 580],
        scGap: [0, 30, 148],
        scTitleMaxWidth: ['none', 'none', '325px'],
        scImageMargins: {
          right: ['5px', '-36.7%', '30px'],
          bottom: ['40px', '0', '0'],
          left: [`0`, `0`, '0'],
        },
      },
      {
        title: 'Easier deployment and purchasing',
        description: [
          'Our dynamically generated and white label websites and apps ensure simple, beautiful customer experiences with a single point of data capture.',
          { tag: 'br' },
          { tag: 'br' },
          'Insurance product purchasing and deployment is made frictionless thanks to personalised, reliable and fully responsive web pages and platforms.',
          { tag: 'br' },
          { tag: 'br' },
          'Our one-touch approach ensures that the key information required for placement and underwriting is provided upfront, directly by the customer.',
        ],
        // image: {
        //   url: withPrefix('img/ArTextWithImage6.png'),
        // },
        animation: {
          id: 'distribute_mobile',
        },
        scComponentMargins: {
          top: ['37px', '38px', '160px'],
          bottom: ['0', '0', '0'],
        },
        scTextWrapperPaddings: {
          top: ['0', '50px', '0'],
          bottom: ['50px', '50px', '0'],
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        // READY ^^

        // TODO: FInish The config!!!

      },
      {
        title: 'Simple integration with existing systems',
        description: [
          'The ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' platform allows for simple integration with your existing applications, so there’s no need to enter data more than once.',
          { tag: 'br' },
          { tag: 'br' },
          'All applications can combine with your existing setups or be built upon our programs.',
          { tag: 'br' },
          { tag: 'br' },
          'Compatibility with a broad range of devices and operating systems ensures you reach every potential customer.',
        ],
        image: {
          alt: 'Seamlesly integrate insurance applications',
          url: withPrefix('img/ArTextWithImageDark1.png'),
        },
        scColors: [variables.colors.black, variables.colors.white],
        scComponentPaddings: {
          top: ['40px', '80px', '160px'],
          bottom: ['0', '0', '0'],
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scImageWidth: [null, 550, 550],
        scGap: [0, 51, 130],
        scImageMargins: {
          right: ['19px', '-32.2%', `${ 60 / variables.percentageFactorDesktop * 100 }%`],
          bottom: ['40px', '0', '0'],
          left: [`6px`, `0`, '0'],
        },
      },
      {
        title: 'Completely unique branding',
        description: [
          'Our applications are a blank canvas for your business.',
          { tag: 'br' },
          { tag: 'br' },
          'The ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' platform allows for visual customisation or integration with your existing applications using our Application Programming Interface (APIs) and Software Development Kits (SDKs), letting you own the full customer relationship.',
        ],
        animation: {
          id: 'distribute_branding',
        },
        scColors: [variables.colors.black, variables.colors.white],
        scTitleBottomMargins: ['20px', '47px', '30px'],
        scComponentPaddings: {
          top: ['10px', '45px', '45px'],
          bottom: ['40px', '0', '0'],
        },
        scImageWidth: [null, 630, 600],
        scGap: [0, 0, 180],
      },
    ],
  },
}
